var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowCta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 14 14.8",
    style: {
      enableBackground: "new 0 0 14 14.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#FFFFFF;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1.414)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,6h12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6,12l6-6L6,0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowCta);
export default __webpack_public_path__ + "static/media/arrow-cta.5da8e8b3e48f24b4bf7f516b48c5e158.svg";
export { ForwardRef as ReactComponent };